import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { OOCPackageItemKeys } from '../../api/Constants';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import Utils from '../../utils';
import Screens from '../../screens';
import transformObjectResponseKeys from '../../utils/transformObjectResponseKeys';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import store from '../../state/store';
import initApp from '../../lib/load/initApp';
import audio from '../../utils/audio';
import { FE_SNEAK_PEEK } from '../../utils/featureFlags/constants';
import useFeatureFlags from '../../hooks/useFeatureFlags.js';
import QueryParamsProxy from '../../utils/queryParamProxy';
import { isEqual } from '../../utils/object';
import ActionsInterface from '../../api/ActionCommandsInterface';
import Emitter from '../../services/EmitterService';
import { actionCommandHandler } from '../../api/ActionCommandsInterface/utils/actionCommandHandler';
import { EVENT_EMITTER_TYPE, FTUE_STEPS_KEYS } from '../../constants';
var INIT_APP_MIN_COOLDOWN = 3600;

var LobbyOverlay = /*#__PURE__*/function (_Component) {
  _inherits(LobbyOverlay, _Component);

  var _super = _createSuper(LobbyOverlay);

  function LobbyOverlay() {
    var _this;

    _classCallCheck(this, LobbyOverlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      loading: true,
      modalsLoaded: false,
      actionCommandsFirstTime: true
    };
    _this._checkToCallInitApp = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(new Date().getDate() !== new Date(_this.props.lastInitApp).getDate())) {
                _context.next = 9;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return initApp.bind(_assertThisInitialized(_this))();

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));
    _this.handleOnLoadModals = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props$onboardin;

      var _useFeatureFlags, hasFeature, _this$props, initAppResponse, initialModal, isFtueShowing, purchaseFlowPromise, i, welcomeNewsReceivedPromise, LimitedTimeOfferReceivedPromise, sneakPeekReceivedPromise, outOfCoinsResponse, _this$props2, pendingMessages, claimPendingMessages, promoLinks, trigger, eventPayload;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _useFeatureFlags = useFeatureFlags(), hasFeature = _useFeatureFlags.hasFeature;
              _this$props = _this.props, initAppResponse = _this$props.initAppResponse, initialModal = _this$props.initialModal;

              if (!(initialModal === Screens.PurchaseSucceeded || initialModal === Screens.PurchaseFlow)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              isFtueShowing = false;
              /* #endregion */

              audio.pauseSfx();

              _this.setState({
                loading: false
              });
              /* Link Account */


              if (initAppResponse.SETTINGS) {
                _this.props.isAccountLinked(initAppResponse.SETTINGS.linkedCasinoId);

                _this.props.setCurrentMemberLevel(initAppResponse.CURRENT_MEMBER_LEVEL);
              }

              if (!(initialModal === Screens.CurrencySelector)) {
                _context2.next = 12;
                break;
              }

              purchaseFlowPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, initialModal));
              _context2.next = 12;
              return purchaseFlowPromise;

            case 12:
              if (_this.props.ftueStep > FTUE_STEPS_KEYS.INITIAL || _this.props.actionCommands.length > 0) isFtueShowing = true; // Welcome News

              if (!(!isFtueShowing && _this.props.actionCommands.length === 0 && !_this.props.showTooltip && initAppResponse.WELCOME && initAppResponse.WELCOME.length > 0)) {
                _context2.next = 23;
                break;
              }

              i = 0;

            case 15:
              if (!(i < initAppResponse.WELCOME.length)) {
                _context2.next = 23;
                break;
              }

              _this.props.setWelcomeNews(initAppResponse.WELCOME[i]);

              welcomeNewsReceivedPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.News)); // Wait for each welcome news to be "done"

              _context2.next = 20;
              return welcomeNewsReceivedPromise;

            case 20:
              i++;
              _context2.next = 15;
              break;

            case 23:
              if (!(!isFtueShowing && !_this.props.showTooltip && initAppResponse.LIMITED_TIME_OFFER)) {
                _context2.next = 27;
                break;
              }

              LimitedTimeOfferReceivedPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.LimitedTimeOffer));
              _context2.next = 27;
              return LimitedTimeOfferReceivedPromise;

            case 27:
              _context2.t0 = !isFtueShowing;

              if (!_context2.t0) {
                _context2.next = 31;
                break;
              }

              _context2.next = 31;
              return _this._shouldShowFavouritesUnlockedOnboarding();

            case 31:
              if (!(hasFeature(FE_SNEAK_PEEK) && !isFtueShowing && initAppResponse.SNEAK_PEEK && !((_this$props$onboardin = _this.props.onboardingsSeen) === null || _this$props$onboardin === void 0 ? void 0 : _this$props$onboardin.includes(ONBOARDING_FLOWS.SNEAK_PEEK)))) {
                _context2.next = 36;
                break;
              }

              sneakPeekReceivedPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.SneakPeekOnboarding));
              _context2.next = 35;
              return sneakPeekReceivedPromise;

            case 35:
              _this.props.markOnboardingSeen(ONBOARDING_FLOWS.SNEAK_PEEK);

            case 36:
              /* Out_of_Coins */
              if (initAppResponse.OUT_OF_COINS) {
                outOfCoinsResponse = transformObjectResponseKeys(initAppResponse.OUT_OF_COINS, OOCPackageItemKeys);

                _this.props.setOutOfCoinOfferResponse(outOfCoinsResponse);

                _this.props.isOutOfCoinsPurchase(false);
              }
              /* Dev user */


              _this.props.setIsDevUser(initAppResponse.DEV_ACCOUNT === 'yes');
              /**
               * Pending Rewards get consumed and translated into Presentable Rewards here:
               *
               * Bonus Links, Welcome Bonus, etc
               */


              _this$props2 = _this.props, pendingMessages = _this$props2.pendingMessages, claimPendingMessages = _this$props2.claimPendingMessages;
              claimPendingMessages(pendingMessages);
              promoLinks = pendingMessages.filter(function (message) {
                return message.type === 'PROMO_LINK';
              });

              if (promoLinks.length > 0 && !promoLinks[0].active && !isFtueShowing) {
                Logger.setActionTrigger('promoLink');
                QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.Shop));
                trigger = Logger.getActionTrigger();
                eventPayload = {
                  balance_before: _this.props.coin.toString(),
                  type: 'regular',
                  trigger: trigger || ''
                };
                Logger.sendEvent(EVENT_TYPES.STORE_OPENED, eventPayload);
              }

              _this.setState({
                modalsLoaded: true
              });

              _this.props.setModalsLoaded(true);

            case 44:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    _this._shouldShowFavouritesUnlockedOnboarding = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props3, onboardingsSeen, userLevel, onboardingsUnlockLevels, favouriteGames, navigation, descriptors, activeKey, descriptor, dynamicTriggeredUnlockedFavourites;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props3 = _this.props, onboardingsSeen = _this$props3.onboardingsSeen, userLevel = _this$props3.userLevel, onboardingsUnlockLevels = _this$props3.onboardingsUnlockLevels, favouriteGames = _this$props3.favouriteGames, navigation = _this$props3.navigation, descriptors = _this$props3.descriptors;
              activeKey = navigation.state.routes[navigation.state.index].key;
              descriptor = descriptors[activeKey];

              if (!(!(onboardingsSeen === null || onboardingsSeen === void 0 ? void 0 : onboardingsSeen.includes(ONBOARDING_FLOWS.FAVOURITES)) && userLevel === onboardingsUnlockLevels[ONBOARDING_FLOWS.FAVOURITES] && favouriteGames.gameList.length === 0 && descriptor.key === Screens.Home)) {
                _context3.next = 7;
                break;
              }

              dynamicTriggeredUnlockedFavourites = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.FavouritesUnlocked));
              _context3.next = 7;
              return dynamicTriggeredUnlockedFavourites;

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    _this._menuChangeHandler = function (id) {
      QueryParamsProxy.navigate(_this.props.navigation, id);
    };

    _this._tooltipButtonClickHandler = function (buttonAction) {
      var _QueryParamProxy$setQ7;

      audio.onClick();
      QueryParamProxy.setQueryParams((_QueryParamProxy$setQ7 = {}, _defineProperty(_QueryParamProxy$setQ7, RouteParamConstants.PARAM_MODAL, buttonAction.modal), _defineProperty(_QueryParamProxy$setQ7, RouteParamConstants.PARAM_SHOP_TYPE, buttonAction.type), _QueryParamProxy$setQ7));

      _this.props.shouldShowTooltip(false);
    };

    _this._dismissModal = function () {
      _this.props.setModal(null);

      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
    };

    return _this;
  }

  _createClass(LobbyOverlay, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.props.token === '')) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                if (!(new Date().getTime() - this.props.lastInitApp > INIT_APP_MIN_COOLDOWN)) {
                  _context4.next = 13;
                  break;
                }

                _context4.prev = 3;
                _context4.next = 6;
                return initApp.bind(this)();

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](3);
                console.error(_context4.t0);

              case 11:
                _context4.next = 14;
                break;

              case 13:
                this.synchronizeLobby(this.props, this.state);

              case 14:
                this.setState({
                  loading: false
                });
                Emitter.on(EVENT_EMITTER_TYPE.ACTION_COMMANDS, function (_ref4) {
                  var actionType = _ref4.actionType,
                      data = _ref4.data;
                  return actionCommandHandler[actionType](data);
                });

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 8]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Emitter.off(EVENT_EMITTER_TYPE.ACTION_COMMANDS);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (Utils.quickObjectComparision(prevProps, this.props) === false) {
        // state change from online to offline will trigger a rerender. Don't fetch gamerooms if offline.
        this.synchronizeLobby(prevProps, prevState);
      }

      if (Utils.quickObjectComparision(prevProps.initAppResponse, this.props.initAppResponse) === false || !isEqual(prevProps.actionCommands, this.props.actionCommands)) this.handleOnLoadModals();

      if (this.state.modalsLoaded && this.props.pendingMessages.length > prevProps.pendingMessages.length) {
        this.props.claimPendingMessages(this.props.pendingMessages);
      }

      if ((!isEqual(prevProps.actionCommands, this.props.actionCommands) || this.state.actionCommandsFirstTime) && this.props.actionCommands.length > 0) {
        this.setState({
          actionCommandsFirstTime: false
        });
        ActionsInterface(this.props);
      }
    }
  }, {
    key: "synchronizeLobby",
    value: function () {
      var _synchronizeLobby = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(prevProps) {
        var _this$props4, navigation, descriptors, activeKey, descriptor, prevActiveKey, prevDescriptor, connectionLostModal, cheatMenuActive, eventPayload;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!store.getState().device.isConnected) {
                  _context5.next = 14;
                  break;
                }

                _this$props4 = this.props, navigation = _this$props4.navigation, descriptors = _this$props4.descriptors;
                activeKey = navigation.state.routes[navigation.state.index].key;
                descriptor = descriptors[activeKey];
                prevActiveKey = prevProps.navigation.state.routes[prevProps.navigation.state.index].key;
                prevDescriptor = prevProps.descriptors[prevActiveKey]; // coming back from a 'not connected' error?

                connectionLostModal = QueryParamProxy.findParam(RouteParamConstants.PARAM_MODAL, false); // coming from the cheat menu?

                cheatMenuActive = QueryParamProxy.findParam(RouteParamConstants.PARAM_CHEAT_MENU_ACTIVE, false);

                if (connectionLostModal === Screens.ConnectionLost && !cheatMenuActive) {
                  QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
                }

                if (!(prevDescriptor.key != Screens.Home && prevDescriptor.key != descriptor.key)) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 12;
                return this._shouldShowFavouritesUnlockedOnboarding();

              case 12:
                _context5.next = 17;
                break;

              case 14:
                // need to inform the user that the connection has been lost
                QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.ConnectionLost));
                eventPayload = {
                  description: 'This app is currently not available.',
                  code: 4
                };
                Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function synchronizeLobby(_x) {
        return _synchronizeLobby.apply(this, arguments);
      }

      return synchronizeLobby;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          descriptors = _this$props5.descriptors,
          navigation = _this$props5.navigation;
      var activeKey = navigation.state.routes[navigation.state.index].key;
      var descriptor = descriptors[activeKey];
      return this.props.render(_objectSpread(_objectSpread({}, this.props), {}, {
        descriptor: descriptor,
        loading: this.state.loading,
        menuChangeHandler: this._menuChangeHandler,
        modal: this.props.modal.modal ? this.props.modal.modal : null,
        dismissModal: this._dismissModal,
        tooltipButtonClickHandler: this._tooltipButtonClickHandler,
        checkToCallInitApp: this._checkToCallInitApp
      }));
    }
  }]);

  return LobbyOverlay;
}(Component);

export { LobbyOverlay as default };